import { createSelector } from 'reselect'

const getCurrentFolder = state => state.myLibrary.folderUID

const myLibraryCurrentFolderSelector = createSelector(
	[getCurrentFolder],
	folderUID => folderUID
)

export default myLibraryCurrentFolderSelector
